
import { defineComponent } from 'vue'
import { format } from 'date-fns'
import { Card, PrimaryButton, Form, Input, Table, Select } from '@design-system/ui'
import CustomInput from '../components/input/Input.vue'
import CustomInputAutocomplete from '../components/input/InputAutoComplete.vue'
import Toast from '../components/Toast.vue'
import { faCheckCircle, faExclamationCircle, faUsers, faGlobeAmericas, faUserShield, faCheckDouble, faFileContract, faLockOpen, faEdit, faSave, faSearch } from '@fortawesome/free-solid-svg-icons'
import SessionService from '../SessionService'
import api from '@/services/api'
import utils from '@/utils'
import { ListSoftwareHousesDTO } from '@/interfaces/ListSoftwareHousesDTO'
import { ShopClientDTO } from '@/interfaces/ShopClientDTO'

export default defineComponent({
  name: 'Estabelecimentos',
  components: {
    Card,
    PrimaryButton,
    Form,
    Table,
    Select,
    Input,
    CustomInput,
    CustomInputAutocomplete,
    Toast
  },
  data () {
    return {
      success: faCheckCircle,
      alert: faExclamationCircle,
      edit: faEdit,
      isRoot: false,
      link: '',
      createLink: '',
      startFilter: '',
      endFilter: '',
      filterDateErrorMessage: '',
      softwareHouseSelected: false,
      searchSoftwareHouseText: '',
      searchEstabelecimentoText: '',
      softwareHouse: this.$store.state.user.nomeFantasia,
      statusSelected: {
        key: '',
        value: ''
      },
      isSoftwareHouseIncorrect: false,
      allSoftwareHouses: [],
      softwareHouses: [],
      softwareHouseCnpj: '',
      companyForm: {
        RazaoSocial: null,
        CNPJ: null,
        MediatorFee: null
      },
      formValidation: {
        RazaoSocial: '',
        CNPJ: '',
        MediatorFee: ''
      },
      buttonNewCompany: true,
      search: null,
      estabelecimentoModal: false,
      registerIndex: 4,
      loading: false,
      loadingEstabelecimento: false,
      loadingSoftwareHouses: false,
      validateBypass: false,
      registerSteps: [
        {
          label: 'Empresa',
          labelClass: 'text-md',
          icon: faGlobeAmericas
        },
        {
          label: 'Representante',
          labelClass: 'text-md',
          icon: faUsers
        },
        {
          label: 'Financeiro',
          labelClass: 'text-md',
          icon: faUserShield
        },
        {
          label: 'Validações',
          labelClass: 'text-md',
          icon: faCheckDouble
        },
        {
          label: 'Contrato',
          labelClass: 'text-md',
          icon: faFileContract
        },
        {
          label: 'Plug-PIX',
          labelClass: 'text-md',
          icon: faLockOpen
        }
      ],
      statuses: {
        cadastro_solicitado: 'Cadastro solicitado',
        cadastro_andamento: 'Cadastro em andamento',
        pendente_validacoes: 'Validações pendentes',
        assinatura_contrato: 'Assinatura de contrato',
        abertura_conta: 'Abertura de conta',
        cadastro_concluido: 'Cadastro concluído'
      },
      buttonIcons: {
        search: {
          icon: faSearch
        },
        save: {
          icon: faSave
        }
      },
      inviteModal: false,
      linkModal: false,
      allEstabelecimentos: [],
      estabelecimentos: [],
      optionsStatus: [],
      estabelecimento: {},
      CNPJ: '',
      error: '',
      message: '',
      hidden: true,
      timeSeen: 8000,
      copied: 'Copiar link',
      materaDetails: { status: '', background: '' }
    }
  },

  mounted () {
    const session = new SessionService()

    if (session.rootAccess()) {
      this.isRoot = true
      this.listSoftwareHouses()

      return
    }

    this.SOFTWARE_HOUSE_CNPJ = session.cnpj()
    this.getData()

    this.link = utils.checkUrl()
  },

  methods: {
    async listSoftwareHouses () {
      this.loadingSoftwareHouses = true
      api.get<ListSoftwareHousesDTO[]>('/software-houses', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
        .then(response => {
          this.allSoftwareHouses = response.data
          this.softwareHouses = this.allSoftwareHouses

          this.loadingSoftwareHouses = false

          setTimeout(() => {
            var evt = new CustomEvent('list')
            window.dispatchEvent(evt)
          }, 1)
        })
        .catch(() => {
          this.loadingSoftwareHouses = false
        })
    },

    async getData (value) {
      if (value) {
        this.updateSearchSoftwareHouseText(value.primaryText)
      }

      this.softwareHouseCnpj = value ? value.id : this.SOFTWARE_HOUSE_CNPJ
      this.loading = true

      try {
        const response = await api.get(`/software-houses/${this.softwareHouseCnpj}/commercial-establishments`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        this.softwareHouseSelected = true
        this.allEstabelecimentos = response.data
        this.estabelecimentos = this.allEstabelecimentos
        this.optionsStatus = this.allEstabelecimentos.reduce((options, estabelecimento) => {
          const optionAlreadyExists = options.find((option) => option.key === estabelecimento.status)
          if (!optionAlreadyExists) {
            options.push({
              value: this.statuses[estabelecimento.status],
              key: estabelecimento.status
            })
          }
          return options
        }, [])
        const selectedAll = {
          value: 'Todos',
          key: 'todos'
        }

        this.optionsStatus.unshift(selectedAll)
        this.statusSelected = selectedAll
        this.loading = false

        if (!this.allEstabelecimentos.length) {
          try {
            const softwareHouse = await api.get(`/software-houses/${this.softwareHouseCnpj}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
              }
            })

            this.companyForm = {
              RazaoSocial: softwareHouse.data.corporateName,
              CNPJ: utils.applyMask('CNPJ', softwareHouse.data.cnpj),
              MediatorFee: Number(softwareHouse.data.mediatorFee).toFixed(2)
            }
          } catch (error) {
            const shopResponse = await api.get<ShopClientDTO>(`/shop/clients/${this.softwareHouseCnpj}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
              }
            })

            const softwareHouseMediatorFeeResponse = await api.get(`/software-houses/mediatorfee/${this.softwareHouseCnpj}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
              }
            })

            const shopResponseData = shopResponse.data
            const shopResponseDataParsed = utils.formatSHOPToSoftwareHouseData(shopResponseData)

            const data = softwareHouseMediatorFeeResponse.data

            this.companyForm = {
              RazaoSocial: shopResponseDataParsed.razaoSocial,
              CNPJ: shopResponseDataParsed.cnpj,
              MediatorFee: data.mediatorFee
            }
          }
        }
      } catch (error) {
        this.loading = false
      }
    },

    getIndex (status) {
      switch (status) {
        case 'cadastro_concluido':
          return 5
        case 'cadastro_validado':
          return 4
        case 'cadastro_iniciado':
          return 2
      }
    },

    searchSoftwareHouses () {
      let softwareHouses = this.allSoftwareHouses

      if (!this.searchSoftwareHouseText) {
        return softwareHouses
      }

      if (this.searchSoftwareHouseText) {
        const softwareHouseCnpj = this.searchSoftwareHouseText.replaceAll('/', '')
          .replaceAll('.', '')
          .replaceAll('-', '')
        softwareHouses = softwareHouses.filter((softwareHouse) => {
          const cnpjWithoutMask = softwareHouse.cnpj.replaceAll('/', '')
            .replaceAll('.', '')
            .replaceAll('-', '')
          return softwareHouse.razaoSocial.toLowerCase().includes(this.searchSoftwareHouseText) ||
            softwareHouse.nomeFantasia.toLowerCase().includes(this.searchSoftwareHouseText.toLowerCase()) ||
            cnpjWithoutMask.includes(softwareHouseCnpj)
        })
      }

      return softwareHouses
    },

    searchEstabelecimentos () {
      this.isSoftwareHouseIncorrect = false
      this.filterDateErrorMessage = ''

      if ((this.startFilter && !this.endFilter) || (!this.startFilter && this.endFilter)) {
        this.filterDateErrorMessage = 'Necessário informar os dois campos'
        return
      }

      if (!this.softwareHouseSelected) {
        this.isSoftwareHouseIncorrect = true
      }

      let estabelecimentos = this.allEstabelecimentos

      if (
        !this.searchEstabelecimentoText &&
        (this.statusSelected.key === 'todos' || !this.statusSelected.key) &&
        (!this.startFilter || !this.endFilter)
      ) {
        this.estabelecimentos = estabelecimentos
        return
      }

      this.loading = true
      if (this.searchEstabelecimentoText) {
        const estabelecimentoCnpj = this.searchEstabelecimentoText.replaceAll('/', '')
          .replaceAll('.', '')
          .replaceAll('-', '')

        estabelecimentos = estabelecimentos.filter((estabelecimento) => {
          const cnpjWithoutMask = estabelecimento.cnpj.replaceAll('/', '')
            .replaceAll('.', '')
            .replaceAll('-', '')
          return estabelecimento.razaoSocial.toLowerCase().includes(this.searchEstabelecimentoText) ||
            estabelecimento.nomeFantasia.toLowerCase().includes(this.searchEstabelecimentoText.toLowerCase()) ||
            cnpjWithoutMask.includes(estabelecimentoCnpj)
        })
      }

      if (this.statusSelected.key !== 'todos' || !this.statusSelected.key) {
        estabelecimentos = estabelecimentos.filter((estabelecimento) => {
          return estabelecimento.status === this.statusSelected.key
        })
      }

      if (this.startFilter && this.endFilter) {
        estabelecimentos = estabelecimentos.filter((estabelecimento) => {
          if (estabelecimento.dataAtivacao) {
            const dataAtivacao = new Date(estabelecimento.dataAtivacao)
            const dataAtivacaoFormatted = format(dataAtivacao, 'yyyy-MM-dd')
            return dataAtivacaoFormatted >= this.startFilter && dataAtivacaoFormatted <= this.endFilter
          }
        })
      }

      this.estabelecimentos = estabelecimentos
      this.loading = false
    },

    handleStatus (selected) {
      this.statusSelected = selected
    },

    updateSearchSoftwareHouseText (value) {
      this.searchSoftwareHouseText = value
      this.softwareHouses = this.searchSoftwareHouses()
    },

    formatDate (date: string) {
      const dateNew = new Date(date)
      return format(dateNew, 'dd/MM/yyyy')
    },

    copyToClipboard () {
      const el = document.createElement('textarea')
      el.value = this.createLink
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.copied = 'Link copiado com sucesso'
    },

    closeModal () {
      this.estabelecimentoModal = false
    },

    async generateLink () {
      Object.keys(this.companyForm).forEach((field) => {
        if (['CNPJ', 'RazaoSocial'].includes(field) && !this.companyForm[field]) {
          this.formValidation[field] = 'Este campo é obrigatório.'
        }

        if (field === 'MediatorFee') {
          const mediatorFee = this.companyForm[field].replaceAll(
            '.',
            ''
          )
            .replaceAll(',', '.')
            .replaceAll('R$ ', '')

          if (parseFloat(mediatorFee) <= 0) {
            this.formValidation[field] = 'A tarifa padrão deve ser maior que zero.'
          }
        }

        utils.validate(
          field,
          this.companyForm,
          this.formValidation,
          this.clientType,
          true
        )
      })

      if (Object.keys(this.formValidation).length > 0) {
        return
      }

      this.error = ''
      this.buttonNewCompany = false
      await api.get(`/estabelecimentos-comerciais/${this.SOFTWARE_HOUSE_CNPJ}/${this.companyForm.CNPJ.replaceAll('/', '')
            .replaceAll('.', '')
            .replaceAll('-', '')}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).then(dynamoEstabelecimentoComercial => {
        if (dynamoEstabelecimentoComercial.data) {
          this.error = 'Aguardando Finalização'
          this.inviteModal = false
          this.linkModal = true
          this.buttonNewCompany = true
          this.handleLinkGeneration(dynamoEstabelecimentoComercial.data.uuid)
        }
      }).catch((error) => {
        console.log(error.response.data)
        this.buttonNewCompany = true
      })

      if (this.error === '') {
        await api.post('/pre-register/estabelecimento-comercial',
          {
            cnpj: this.companyForm.CNPJ.replaceAll('/', '')
              .replaceAll('.', '')
              .replaceAll('-', ''),
            razaoSocial: this.companyForm.RazaoSocial,
            mediatorFee: parseFloat(this.companyForm.MediatorFee.replaceAll(',', '.').replaceAll('R$ ', '')),
            softwareHouseCnpj: this.SOFTWARE_HOUSE_CNPJ.toString()
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }).then((response) => {
          this.inviteModal = false
          this.linkModal = true
          this.handleLinkGeneration(response.data.uuid)
        }).catch(error => {
          this.hidden = false
          this.buttonNewCompany = true
          this.message = error.response.data.error_messages[0] ? error.response.data.error_messages[0] : 'Erro ao cadastrar Estabelecimento Comercial.'
          setTimeout(() => { this.hidden = true }, this.timeSeen)
        })
      }
      this.getData()
    },

    handleLinkGeneration (uuid: string) {
      this.createLink = `${this.link}/estabelecimento/${uuid}`
    },

    handleEdit (cnpj: string) {
      this.$router.push(`/estabelecimentos/${this.softwareHouseCnpj}/${cnpj.replace(/\D/g, '')}/edit`)
    },

    hide () {
      this.hidden = true
    },

    changeField (index, value) {
      this.companyForm[index] = value

      utils.validate(
        index,
        this.companyForm,
        this.formValidation,
        this.clientType,
        true
      )
    }
  },

  beforeMount () {
    this.$store.commit('changeActiveMenu', 2)
  }
})
